import { ListTerrotoriesSortOrder } from 'generated/graphql'
import type { INormalizedDataForTerritoriesTable } from 'utils/getNormalizedTerritoriesDataForTerritoriesTable'

import type { TTableOrder } from './global-topic.types'

export const handleSort = (data: INormalizedDataForTerritoriesTable[], order: TTableOrder) => {
  const sortField = order.field
  return data.sort((a, b) => {
    if (order.order === ListTerrotoriesSortOrder.Asc) {
      return a[sortField] - b[sortField]
    }
    return b[sortField] - a[sortField]
  })
}
